export default "/_next/static/chunks/fonts/Roboto-Bold-latin-a6d79156a10fbf69e34cf334d29df6b5.woff2";